export const AdType = {
  Rewarded: 'rewarded',
  Interstitial: 'interstitial',
  Preroll: 'interstitial',
  Midroll: 'interstitial',
  Display: 'display',
};
